import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Navigate, Route, Routes as Switch } from 'react-router-dom';
import { If } from '~/components';
import { FluidTheme, isEmpty } from '~/modules';
import {
  CreditSimulationConfirmation,
  CreditSimulationInstallments,
  CreditSimulationIntro,
  CreditSimulationSummary,
  CreditSimulationValue,
} from '~/scenes';
import { useStores } from '~/utils';
import { Routes } from './routing';

const RoutesContainer: React.FC = () => {
  const {
    theme: { theme },
  } = useStores();
  const [themeVerificated, setThemeVerificated] = useState<FluidTheme>(theme);

  useEffect(() => {
    setThemeVerificated(theme);
  }, [theme]);

  return (
    <If condition={!isEmpty(themeVerificated)}>
      <Switch>
        <Route
          path="*"
          element={<Navigate to={Routes.CREDIT_SIMULATION_INTRO} />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_INTRO}
          element={<CreditSimulationIntro />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_VALUE}
          element={<CreditSimulationValue />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_INSTALLMENTS}
          element={<CreditSimulationInstallments />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_SUMMARY}
          element={<CreditSimulationSummary />}
        />
        <Route
          path={Routes.CREDIT_SIMULATION_CONFIRMATION}
          element={<CreditSimulationConfirmation />}
        />
      </Switch>
    </If>
  );
};

export { Routes };
export default observer(RoutesContainer);
